// @flow

import React from 'react';
import ModalWithOverlay from '../../shared/modal/ModalWithOverlay';
import Topic from '../../shared/topic/Topic';
import markdown from '../../../lib/utils';

type SectionType = string | Array<string>;

type SectionsType = {
  item: string,
  sections: [SectionType],
  ariaHidden: boolean,
};

type SectionReturnType = React.Element<*> | Array<React.Element<*>> | null;

type Props = {
  item: string,
  label: string,
  sections: [ SectionType ],
  visited: boolean,
  content: Object,
  modalVisible: boolean,
  onModalShow: () => null,
  onModalHide: () => null,
  isAnyModalVisible: boolean,
};


const Sections = ({ sections, item, ariaHidden }: SectionsType): [SectionReturnType] => {
  let isInstructionAvailable = true;

  return sections.map((section: SectionType): SectionReturnType => {
    if (typeof section === 'string') {
      return <div key={section} id={`${item}-modal-body`} dangerouslySetInnerHTML={{ __html: markdown(section) }} />;
    }

    if (Array.isArray(section)) {
      if (isInstructionAvailable) {
        isInstructionAvailable = false;
        return section.map((topic: string, i: number): React.Element<*> => (
          <Topic topic={topic} key={topic} ariaHidden={ariaHidden} isFirst={i === 0} />
        ));
      }

      return section.map((topic: string): React.Element<*> => (
        <Topic topic={topic} key={topic} ariaHidden={ariaHidden} />
      ));
    }

    return null;
  });
};

export default class HealthPregnancyMenuItem extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.modalHeadingRef = React.createRef();
    this.buttonRef = React.createRef();
  }

  componentDidUpdate(prevProps: Props) {
    const { modalVisible } = this.props;
    if (!prevProps.modalVisible && modalVisible) {
      this.modalHeadingRef.current.focus();
    }
    if (prevProps.modalVisible && !modalVisible) {
      this.buttonRef.current.focus();
    }
  }

  render() {
    const {
      item,
      label,
      visited,
      sections,
      content,
      onModalShow,
      onModalHide,
      modalVisible,
      isAnyModalVisible,
    } = this.props;

    return (
      <div className={`item ${item}`}>
        <button
          ref={this.buttonRef}
          className="item-button"
          type="button"
          onClick={onModalShow}
          aria-hidden={isAnyModalVisible}
          disabled={isAnyModalVisible}
          tabIndex="0"
        >
          <span className="image" />
          {visited && <span className="visited-overlay-image" />}
          {label}
          <span className="visually-hidden">
            {visited ? ', already viewed' : ', not yet viewed'}
          </span>
        </button>

        <ModalWithOverlay
          id={item}
          isModalOn={modalVisible}
          clickHandler={onModalHide}
          closeBox={content.closeBox}
        >
          <header className="rainbow mobile">
            <div className="yellow-box box" />
            <div className="red-box box" />
            <div className="lime-box box" />
            <div className="green-box box" />
            <div className="blue-box box" />
            <div className="indigo-box box" />
          </header>
          <div className="modal-content">
            <h1 id={`${item}-modal-title`} ref={this.modalHeadingRef} tabIndex="-1" className="heading focus-start"><span />{label}</h1>
            {
              modalVisible && (
                <Sections
                  sections={sections}
                  item={item}
                  ariaHidden={!isAnyModalVisible || !modalVisible}
                />
              )
            }
          </div>
          <div className="nav-buttons-container fake mobile">
            <button onClick={onModalHide} type="button" className="nav-button left">« {content.navigation.backText}</button>
          </div>
        </ModalWithOverlay>
      </div>
    );
  }
}
